import { Translator } from 'Translator';
import { mapSubcategoryToCategory } from 'data/filters';
import { SearchFilters } from 'model/Filters';
import { Account } from 'model/IChat';
import LocalsCarousel from 'modules/overview/components/LocalsList/LocalsCarousel';
import SeeAllButton from 'modules/search/components/HostSlider/SeeAllButton';
import React, { memo } from 'react';
import { translateCity, translateCountry } from 'utils/TranslationHelper';

const CSS = require('./HostSlider.less');

type HostSliderProps = {
  hosts: Account[];
  filters: SearchFilters;
  limit?: number;
  hasMoreResultsBelow?: boolean;
};

function HostSlider({
  hosts,
  filters,
  limit,
  hasMoreResultsBelow,
}: HostSliderProps) {
  if (hosts.length === 0) {
    return null;
  }

  const destination = filters.city
    ? translateCity(filters.city, true)
    : filters.country
    ? translateCountry(filters.country, true)
    : '';

  const showSeeAllLink = () => {
    const hostsAreLimited = limit ? hosts.length > limit : true;
    const experienceTypeFilter = filters.activeFilters.find(
      (f) => f.uid === 'activityType.activity',
    );
    const experienceTypeFilterIsActivity = experienceTypeFilter
      ? experienceTypeFilter.subOptions.find((f) => f.value === 'activities')
      : false;

    const subcategoryFilter = filters.activeFilters.find(
      (f) => f.uid === 'subcategory.items[]',
    );
    const subcategoryIsActivity = subcategoryFilter
      ? !subcategoryFilter.subOptions.find(
          (subOption) =>
            mapSubcategoryToCategory[subOption.value] === 'activities',
        )
      : false;

    return (
      hostsAreLimited &&
      !experienceTypeFilterIsActivity &&
      !subcategoryIsActivity
    );
  };

  return (
    <div className={CSS.HostSliderContainer}>
      {hasMoreResultsBelow && (
        <span className={CSS.MoreToursText}>
          {Translator.translateText(
            'Common.moreToursBelow',
            {},
            'More tours below',
          )}{' '}
          <span className={CSS.Caret}>▼</span>
        </span>
      )}
      <LocalsCarousel
        country={filters.country}
        city={filters.city}
        locals={hosts.slice(0, limit)}
        destination={destination}
      />
      {showSeeAllLink() && <SeeAllButton filters={filters} />}
    </div>
  );
}

export default memo(HostSlider);
